import { createSlice } from "@reduxjs/toolkit";

const MAX_STORED_EVENTS = 200;

const realtimeSlice = createSlice({
  name: "realtime",
  initialState: {
    lastEvent: null,
    events: [],
  },
  reducers: {
    setRealtimeEvent: (state, action) => {
      const nextEvent = action.payload || null;
      if (!nextEvent) return;

      state.lastEvent = nextEvent;
      state.events.unshift(nextEvent);

      if (state.events.length > MAX_STORED_EVENTS) {
        state.events = state.events.slice(0, MAX_STORED_EVENTS);
      }
    },
    clearRealtimeEvents: (state) => {
      state.lastEvent = null;
      state.events = [];
    },
  },
});

export const { setRealtimeEvent, clearRealtimeEvents } = realtimeSlice.actions;
export default realtimeSlice.reducer;
